// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: true,
	AUTHAPIURL: 'https://ustcdev.com/CTMS-API/public/api/',
	sessionTimeOut: 360000,
	APPLICATION_ID: 1,
	GOOGLE_RECAPTCHA: true,
	WHATSAPP_PHONE_NO: 918287699730,
	APP_PUBLIC_URL: 'https://ustcdev.com/CTMS-API/public/',
	APP_ID_PRIVATE_LABORATORY : 1,
	APP_ID_COLLECTION_CENTER : 2,
	APP_ID_MINISTRY_OF_HEALTH : 3,
	APP_ID_AIRPORT_PERSONAL : 4,
	APP_ID_NOWNOW_AGENT : 5,

	//USER ROLES
	private_laboratory_user: 4,

};
